import { render } from "./Checkbox.vue?vue&type=template&id=23186fa5&scoped=true"
import script from "./Checkbox.vue?vue&type=script&lang=ts"
export * from "./Checkbox.vue?vue&type=script&lang=ts"

import "./Checkbox.vue?vue&type=style&index=0&id=23186fa5&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-23186fa5"

export default script